import { render, staticRenderFns } from "./NoJpWagerSection.vue?vue&type=template&id=14ed3200&scoped=true"
import script from "./NoJpWagerSection.vue?vue&type=script&lang=js"
export * from "./NoJpWagerSection.vue?vue&type=script&lang=js"
import style0 from "./NoJpWagerSection.vue?vue&type=style&index=0&id=14ed3200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ed3200",
  null
  
)

export default component.exports